import { IKnmSubject248 } from 'APIPackage/KnmModule/interfaces/IKnmSubject248';

import { IKnmErknmFormOrganizationAdd } from '../interfaces/IKnmErknmFormOrganizationAdd';
import { IKnmErknmFormSubject } from '../interfaces/IKnmErknmFormSubject';
import { IKnmErknmOrganizationTemplateSelectOption } from '../interfaces/IKnmErknmOrganizationTemplateSelectOption';
import { generateOrganizationTemplateText } from './generateOrganizationTemplateText';
import { DictionaryUUIDsEnum } from '../../../CorePackage/DictionariesModule/enums/DictionaryUUIDsEnum';

export const createOrganizationTemplateSelectOption = (
  organization: IKnmErknmFormSubject | IKnmErknmFormOrganizationAdd | IKnmSubject248,
): IKnmErknmOrganizationTemplateSelectOption => {
  const organizationFromSubject: IKnmErknmFormSubject = organization as IKnmErknmFormSubject;
  const locationFields = {
    locationregion: organizationFromSubject.locationregion ?? undefined,
    locationnotInFIAS: organizationFromSubject.locationnotInFIAS,
    locationmanualAddress: organizationFromSubject.locationmanualAddress,
    locationfiasRegion: organizationFromSubject.locationfiasRegion ?? undefined,
    locationisErrorFiasValue: organizationFromSubject.locationisErrorFiasValue,
    locationRegionCodeFromFns: organizationFromSubject.locationRegionCodeFromFns,
  };

  return {
    id: 'listId' in organization ? organization.listId : organization.guid || '',
    label: generateOrganizationTemplateText(
      organization.inn || undefined,
      organization.ogrn || undefined,
      organization.organizationName || undefined,
      organization.rafpNza || undefined,
    ),
    value: 'listId' in organization ? organization.listId : organization.guid || '',
    inn: organization.inn || undefined,
    ogrn: organization.ogrn || undefined,
    organizationName: organization.organizationName || undefined,
    isFiz: organization.isFiz || undefined,
    isDocumentOrganization: organization.isDocumentOrganization || false,
    nkoForeignAgentsRegistryNumber: organization.nkoForeignAgentsRegistryNumber || undefined,
    nkoForeignAgentsRegistryInclusionDate: organization.nkoForeignAgentsRegistryInclusionDate || undefined,
    nkoForeignAgentsRegistryExclusionDate: organization.nkoForeignAgentsRegistryExclusionDate || undefined,
    isNko: !!organization.nkoForeignAgentsRegistryInclusionDate,
    subjectType: organization.subjectType
      ? {
          id: 0,
          code: organization.subjectType.code,
          title: organization.subjectType.title,
          label: organization.subjectType.title,
          value: {
            dictId: DictionaryUUIDsEnum.TARGET_ENTITY,
            dictVersionId: '',
          },
        }
      : undefined,
    kpp: organization.kpp || undefined,
    smevRequestStatus: organization.smevRequestStatus || undefined,
    rafpNza: organization.rafpNza || undefined,
    isForeignSubjectAgencyNotRegistredInRf: organization.isForeignSubjectAgencyNotRegistredInRf || undefined,
    country: organization.country
      ? {
          id: organization.country.id,
          title: organization.country.title,
          label: organization.country.title,
          value: organization.country.id,
        }
      : undefined,
    locationAddress: organization.locationAddress || undefined,
    workAddress: organization.workAddress || undefined,
    factualAddress: organization.factualAddress || undefined,
    snils: organization.snils || undefined,
    document: organization.document || undefined,
    ervkId: organization.ervkId || undefined,
    isSonko: organization.isSonko || undefined,
    mspCode: organization.mspCode || undefined,
    isPresentInItRegistry:
      typeof organization.isPresentInItRegistry === 'boolean' ? organization.isPresentInItRegistry : undefined,
    itAccreditationResponse: organization.itAccreditationResponse || undefined,
    smevItAccreditationRequestStatus: organization.smevItAccreditationRequestStatus || undefined,
    checkSubjectResult: organization.checkSubjectResult || null,
    inspectionResults: organization.inspectionResults,
    ...locationFields,
  };
};
